import { ApolloError } from "@apollo/client";
import { toast } from "react-toastify";

export const errorToastPopup = (error: ApolloError) => {
  toast.error(error?.networkError || "Something is wrong", {
    position: "bottom-left",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};
